import React, { useContext, useEffect, useState } from 'react';
import gql from 'graphql-tag';
import * as qs from 'query-string';
import { useQuery } from '@apollo/react-hooks';
import { useParams, useLocation } from 'react-router-dom';
import { Loading } from '../../components/Loading';
import { growlErrors } from '../../utils/NotificationUtil';
import { NotificationContext } from '../../components/GrowlNotifications';
import ChangeSubscription from './ChangeSubscription';

const CHANGE_SUBSCRIPTION_CONFIG_QUERY = gql`
  query changeSubscriptionConfigQuery($accountId: ID!) {
    account(id: $accountId) {
      id
      type
      managedAccounts {
        id
        displayName
        type
        subscriptionInformation {
          hasActiveSubscription
          currentSubscription {
            numberOfEmployees
            duration
            subscriptionPeriodId
            payedAmount
          }
        }
      }
    }
  }
`;

const DEFAULT_MANAGING_ACCOUNT_STATE = {
  id: null,
  type: null,
};

const DEFAULT_CLIENT_ACCOUNT_STATE = {
  id: null,
  displayName: null,
  type: null,
  subscriptionInformation: {
    hasActiveSubscription: true,
    currentSubscription: {
      numberOfEmployees: null,
      subscriptionPeriodId: null,
      payedAmount: null,
    },
  },
};

const ChangeSubscriptionForClient = () => {
  const growl = useContext(NotificationContext);
  const { aid: managingAccountId } = useParams();
  const { search } = useLocation();
  const { clientId } = qs.parse(search);

  const [managingAccount, setManagingAccount] = useState(DEFAULT_MANAGING_ACCOUNT_STATE);
  const [clientAccount, setClientAccount] = useState(DEFAULT_CLIENT_ACCOUNT_STATE);

  const { loading, error, data } = useQuery(CHANGE_SUBSCRIPTION_CONFIG_QUERY, {
    variables: {
      accountId: managingAccountId,
    },
    fetchPolicy: 'no-cache',
  });

  const { account: accountFromQuery } = data;

  useEffect(() => {
    if (accountFromQuery) {
      setManagingAccount({
        id: accountFromQuery.id,
        type: accountFromQuery.type,
      });

      const currentClientAccount = accountFromQuery.managedAccounts.filter(
        (managedAccount) =>
          !!managedAccount.subscriptionInformation && managedAccount.id === clientId,
      )[0];

      setClientAccount(currentClientAccount);
    }
    // eslint-disable-next-line
  }, [accountFromQuery]);

  const dataIsLoading =
    loading || managingAccount === DEFAULT_MANAGING_ACCOUNT_STATE || clientAccount === DEFAULT_CLIENT_ACCOUNT_STATE;

  if (dataIsLoading) {
    return <Loading />;
  }

  if (error) {
    growlErrors(growl, error);
  }

  return <ChangeSubscription managingAccount={managingAccount} clientAccount={clientAccount} />;
};

export default ChangeSubscriptionForClient;
